import { render, staticRenderFns } from "./PrintPreview.vue?vue&type=template&id=1345efc4&scoped=true&"
import script from "./PrintPreview.vue?vue&type=script&lang=ts&"
export * from "./PrintPreview.vue?vue&type=script&lang=ts&"
import style0 from "./PrintPreview.vue?vue&type=style&index=0&id=1345efc4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1345efc4",
  null
  
)

export default component.exports